import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import styled from 'styled-components';

import Shifts from './ScheduleShifts';
import Title from '../Title';

import messages from '../../messages';

const ScheduleContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-size: 15px;
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-all;
  text-align: left;
`;

const ShiftsContainer = styled.div`
  :first-child {
    padding-left: 0px !important;
  }
  span {
    padding: 5px 5px 0 0;
    .shift {
      padding: 0 5px;
    }
  }
  flex: 1;
`;

const DayContainer = styled.div`
  display: flex;
  padding: 5px ${({ theme }) => theme.constants.lateralSpace} 5px 0;
  &.selected_day {
    font-weight: bold;
  }
  .day_name {
    flex: 1;
  }
`;

function Schedule({ schedule, timeFormat }) {
  const date = new Date();
  const today = date.getDay() + 1;

  return (
    <ScheduleContainer>
      <Title>Horarios</Title>
      {schedule.map(({ name, shifts, index }) => (
        <DayContainer
          key={name}
          className={classnames({
            selected_day: Number(index) === Number(today),
          })}
        >
          <div className="day_name">{name}</div>
          <ShiftsContainer>
            {shifts.length === 0 ? (
              <FormattedMessage
                key={`${name}-noSchedule`}
                {...messages.noDelivery}
              />
            ) : (
              <Shifts shifts={shifts} timeFormat={timeFormat} />
            )}
          </ShiftsContainer>
        </DayContainer>
      ))}
    </ScheduleContainer>
  );
}

Schedule.propTypes = {
  schedule: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.string,
      name: PropTypes.string,
      shifts: PropTypes.arrayOf(
        PropTypes.shape({ to: PropTypes.string, from: PropTypes.string }),
      ),
    }),
  ),
  timeFormat: PropTypes.string.isRequired,
};

export default React.memo(Schedule);
